import {NgModule} from '@angular/core';
import {DaterangepickerDirective} from './daterangepicker.directive';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [ CommonModule ],
  declarations: [ DaterangepickerDirective ],
  exports: [ DaterangepickerDirective ]
})
export class DaterangepickerModule {}



// WEBPACK FOOTER //
// ./src/app/directives/daterangepicker/daterangepicker.module.ts